export default { 
  name : 'room.occupancyCounts',
  objectType : 'room',
  valueType : 'string',
  displayName : 'Occupancy Counts',
  get : data => JSON.stringify( data )
}
